// peopleFieldProfiles.js

export const getPeopleProfiles = (value) => {
    const list = Array.isArray(value) ? value : value ? [value] : [];

    return list
        .map((entry, index) => {
            if (!entry) return null;

            if (typeof entry === 'string') {
                const key = entry.trim();
                if (!key) return null;
                return {
                    key,
                    name: '',
                    coverUrl: '',
                };
            }

            if (typeof entry !== 'object') return null;

            const key = String(entry?.userKey || entry?.key || '').trim();
            const fallbackKey = key || `person_${index}`;
            const candidates = [
                entry?.name,
                entry?.data_profile?.name,
                entry?.title,
                entry?.email,
            ];
            const rawName = candidates.find((candidate) => {
                const normalized = String(candidate || '').trim();
                return normalized && normalized !== key;
            });
            const name = String(rawName || '').trim();

            return {
                key: fallbackKey,
                name,
                coverUrl: entry?.coverUrl || '',
            };
        })
        .filter(Boolean);
};

export default getPeopleProfiles;